import { defaultDictionaryValueMissing } from '../repository';

export type SearchKey =
	| 'BtnSearch'
	| 'EnterKeyword'
	| 'ErrorOccurred'
	| 'Found$NumberResultsFrom'
	| 'FoundAt'
	| 'InputPlaceholder'
	| 'LoadMore'
	| 'RequiredField'
	| 'SearchForRelatedTags'
	| 'ShowAll'
	| 'TagsOther'
	| 'TypeArticlePage'
	| 'TypeContactPersonPage'
	| 'TypeContentPage'
	| 'TypeEventCatalogPage'
	| 'TypeEventPage'
	| 'TypeHomePage'
	| 'TypeNewsCatalogPage'
	| 'TypeNewsPage'
	| 'TypeSubjectPage'
	| 'YourSearchGave$NumberResults';

export const getDefaultSearchValue = (key: SearchKey): string => {
	switch (key) {
		case 'EnterKeyword':
			return 'Indtast søgeord 1';
		case 'ErrorOccurred':
			return 'Der opstod en fejl i søgningen. Prøv venligst igen.';
		case 'Found$NumberResultsFrom':
			return 'Fandt {value1} resulter fra';
		case 'BtnSearch':
			return 'Søg';
		case 'SearchForRelatedTags':
			return 'Søg efter relaterede emner';
		case 'RequiredField':
			return 'Påkrævet';
		case 'FoundAt':
			return 'Fundet under';
		case 'YourSearchGave$NumberResults':
			return 'Din søgning gav {value1} resultater';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
